import {Loadable} from 'app/components/general/lazyLoader';
import {DetailLoadingPage} from 'app/general/loading/DetailLoadingPage';

import type {SweetError} from 'app/utils/errors';

export const LoadableQuizEditPage = Loadable<SweetError, unknown>({
  loader: () =>
    import(
      /* webpackChunkName: "edit-pages" */
      '.'
    ),
  //eslint-disable-next-line react/display-name
  LoadingComponent: DetailLoadingPage,
});
